import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AiFillLeftCircle } from "react-icons/ai";
import { AiFillRightCircle } from "react-icons/ai";
import "./Arowbutton.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import baseurl from "./Baseurl";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";
import { useCart } from "./CartContext";

const FruitsandVagetables = () => {
  let navigate = useNavigate();
  const { triggerCartRefresh } = useCart();

  const [slideIndex, setSlideIndex] = useState(0);
  let [images, setimages] = useState([]);

  const plusSlides = (n) => {
    const newIndex = (slideIndex + n + images.length) % images.length;
    setSlideIndex(newIndex);
  };

  const currentSlide = (n) => {
    setSlideIndex(n);
  };

  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  const CustomPrevArrow = (props) => (
    <button
      className="custom-prev-arrow"
      style={{ right: "60px", top: "-50px", padding: "5px", zIndex: "0" }}
      onClick={props.onClick}
    >
      <i
        className="las la-angle-left"
        style={{
          color: "black",
          border: "1px solid",
          padding: "5px",
          borderRadius: "20px",
          zIndex: "0",
        }}
      />
    </button>
  );

  const CustomNextArrow = (props) => (
    <button
      className="custom-next-arrow"
      style={{ right: "20px", top: "-50px", padding: "5px", zIndex: "0" }}
      onClick={props.onClick}
    >
      <i
        className="las la-angle-right"
        style={{
          color: "black",
          border: "1px solid",
          padding: "5px",
          borderRadius: "20px",
          zIndex: "0",
        }}
      />
    </button>
  );

  const slider1Settings = {
    autoplay: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: slider2,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slider2Settings = {
    autoplay: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: slider1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  let loginpage = () => {
    navigate(`/login`);
  };

  // useStatus
  let [fruits_veg_product_list, setfruits_veg_product_list] = useState([]);
  let [cardstatus, setcardstatus] = useState(true);
  let token = secureLocalStorage.getItem("n_token");
  console.log("token n_token", token);

  let _id = secureLocalStorage.getItem("n_id");
  let [showmodel, setshowmodel] = useState([]);
  let [counter, setcounter] = useState(1);
  let [indexvalue, setindex_vlaue] = useState(0);
  const [currentProductId, setCurrentProductId] = useState(null);

  useEffect(() => {
    fetchFruitsVegProducts();
  }, []);

  const fetchFruitsVegProducts = async () => {
    try {
      const data = { user_id: _id };
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/fruits_veg_product_list`,
        data,
      );

      if (res.data.result) {
        setfruits_veg_product_list(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Single_products handle - FIXED
  let Single_products = (singleproducts) => {
    navigate(`/single_products/${singleproducts}`);
    // if (token) {
    //   navigate(`/single_products/${singleproducts}`);
    // } else {
    //   navigate(`/login`);
    // }
  };

  let Single_products_model = (singleproducts, event) => {
    if (event) {
      event.stopPropagation();
    }

    // if (!token) {
    //   toast.error("Please login to view product details");
    //   window.$('#loginRequiredModal').modal('show');
    //   return;
    // }

    setCurrentProductId(singleproducts);
    console.log(singleproducts);

    try {
      let items = {
        product_id: singleproducts,
        user_id: _id,
      };
      axios
        .post(`${process.env.REACT_APP_API}website/product_details`, items)
        .then((res) => {
          console.log(res.data.data, "product_details");
          if (res.data.result) {
            setimages(res.data.data[0]?.product_image);
            setshowmodel(res.data.data);
            // Modal खोलें
            window.$("#myModal1").modal("show");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  let removelocal_showcard = () => {
    setshowmodel(null);
    secureLocalStorage.setItem("n_singleproducts", null);
    window.$("#myModal1").modal("hide");
  };

  // add favorite cart
  const addfevrate = async (productsid, fav_status, event) => {
    if (event) {
      event.stopPropagation();
    }

    try {
      const items = {
        user_id: _id,
        product_id: currentProductId || productsid,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_favourite_product`,
        items,
        {
          headers: { token },
        },
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        triggerCartRefresh();
        fetchFruitsVegProducts();
        if (currentProductId) {
          Single_products_model(currentProductId);
        }
      } else {
        toast.error(res.data.msg || "Something went wrong");
      }
    } catch (error) {
      toast.error("Product removed from favourites successfully.");
      fetchFruitsVegProducts();
      if (currentProductId) {
        Single_products_model(currentProductId);
      }
    }
  };

  const counter_price = showmodel?.[0]?.price?.[indexvalue] * counter;

  let increment = () => {
    setcounter(counter + 1);
  };

  let decrement = () => {
    if (counter > 1) {
      setcounter(counter - 1);
    }
  };

  let qantity_index = (indexid) => {
    setindex_vlaue(indexid);
  };

  const add_to_cart = async (cart, event) => {
    if (event) {
      event.stopPropagation();
    }

    try {
      const data = {
        user_id: _id,
        product_id: cart._id,
        quantity: cart.quantity?.[0],
        no_of_product: 1,
        mrp: cart.mrp,
        price: cart.price?.[0],
        total_mrp_ammount: cart.mrp,
        total_price_ammount: cart.price?.[0],
        product_name: cart.product_name,
        product_image: cart.product_image?.[0],
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_to_cart`,
        data,
        { headers: { token } },
      );

      if (res.data?.result) {
        setcardstatus(true);
        secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        triggerCartRefresh();
        toast.success("Product added to cart successfully ✅");
        fetchFruitsVegProducts();
      } else {
        toast.error(res.data?.msg || "Failed to add item to cart");
        setcardstatus(false);
      }
    } catch (error) {
      console.log("Add to cart error:", error);
      toast.error("Something went wrong while adding to cart");
      setcardstatus(false);
    }
  };

  const add_to_cart_model = async (modeldata) => {
    try {
      const data = {
        user_id: _id,
        product_id: modeldata?._id,
        quantity: modeldata?.quantity?.[indexvalue],
        no_of_product: counter,
        mrp: modeldata?.mrp,
        price: modeldata?.price?.[indexvalue],
        total_mrp_ammount: modeldata?.mrp,
        total_price_ammount: counter_price,
        product_name: modeldata?.product_name,
        product_image: modeldata?.product_image?.[0],
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_to_cart`,
        data,
        { headers: { token } },
      );

      if (res.data?.result) {
        setcardstatus(true);
        secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        triggerCartRefresh();
        Single_products_model(currentProductId);
        toast.success("Product added to cart successfully ");
      } else {
        toast.error(res.data?.msg || "Failed to add product to cart");
        setcardstatus(false);
      }
    } catch (error) {
      console.log("Add to cart (modal) error:", error);
      toast.error("Something went wrong while adding to cart");
      setcardstatus(false);
      Single_products_model(currentProductId);
    }
  };

  let [categorey, setcategorey] = useState([]);

  useEffect(() => {
    const fetchCategoryList = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}category_list`,
        );
        if (res.data.result) {
          setcategorey(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching category list", error);
      }
    };

    fetchCategoryList();
  }, []);

  let categoryid = (sub_category_list_id) => {
    console.log(sub_category_list_id);
    secureLocalStorage.setItem("n_sub_category_list_id", sub_category_list_id);
    navigate(`/shopscategory`);
  };

  return (
    <div>
      <ToastContainer position="top-center" />

      {/* Login Required Modal */}
      <div className="modal fade" id="loginRequiredModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-warning">
              <h5 className="modal-title text-white">
                <i className="fas fa-exclamation-triangle me-2"></i>
                Login Required
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body text-center py-4">
              <div className="mb-4">
                <i className="fas fa-lock fa-3x text-warning"></i>
              </div>
              <h4 className="mb-3">Please Login First</h4>
              <p className="text-muted mb-4">
                You need to login to view product details and add items to cart.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button
                  className="btn btn-outline-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => navigate("/login")}
                  data-bs-dismiss="modal"
                >
                  Go to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="product-carousel mt-5">
        <div className="container position-relative">
          <div className="row">
            <div className="section-title">
              <h2 className="title">Top Thekua</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="custom-container">
                <div className="custom-col-left">
                  <aside className="sidebar-widgets">
                    <div className="widget">
                      <div className="product-box">
                        <Link
                          to="/shop"
                          className="banner-box-animation"
                          style={{
                            display: "block",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          {/* <img
      className="bannerimg"
      src={`${process.env.REACT_APP_API}uploads/${banners?.[0]?.banner_image}`}
      height={400}
     style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover', 
              display: 'block',
              borderRadius:"10px"
            }}
      alt="Banner"
      onError={(e) => (e.target.src = "/fallback-banner.jpg")}
    /> */}
                          <img
                            src="assets/images/banner/eatthekua.png"
                            alt="images_not_found"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              display: "block",
                              borderRadius: "10px",
                            }}
                          />
                        </Link>
                        <ul className="sidebar-menu">
                          {categorey?.map((items) => {
                            return (
                              <li className="sidebar-menu-item" key={items._id}>
                                <a
                                  className="sidebar-menu-nav-link"
                                  onClick={() => categoryid(items._id)}
                                  href="#"
                                >
                                  {items.category_name}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </aside>
                </div>
                <div className="custom-col-right">
                  <div
                    className="vertical-scroll-container"
                    style={{ marginBottom: "20px" }}
                  >
                    <div className="row">
                      {fruits_veg_product_list?.slice(0, 4).map((items) => (
                        <div
                          className="new-arrival-carousel-item swiper-slide col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
                          key={items._id}
                        >
                          <div
                            className="product-card-list"
                            style={{
                              margin: "0 5px 15px",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <div
                              className="product-card"
                              style={{
                                borderRadius: "20px",
                                overflow: "hidden",
                                minHeight: "363px",
                                background: "#ffffff",
                                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                                position: "relative",
                                border: "1px solid #f0f0f0",
                                transition: "all 0.3s ease",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow =
                                  "0 15px 40px rgba(0,0,0,0.12)";
                                e.currentTarget.style.transform =
                                  "translateY(-5px)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow =
                                  "0 10px 30px rgba(0,0,0,0.08)";
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                              }}
                            >
                              {items.offer_percent !== 0 && (
                                <div
                                  className="badge product-badge"
                                  style={{
                                    position: "absolute",
                                    top: "15px",
                                    left: "15px",
                                    background:
                                      "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
                                    color: "#fff",
                                    borderRadius: "20px",
                                    padding: "6px 14px",
                                    fontWeight: "700",
                                    zIndex: 2,
                                    fontSize: "12px",
                                    boxShadow:
                                      "0 4px 12px rgba(238, 9, 121, 0.3)",
                                  }}
                                >
                                  {items.offer_percent}% OFF
                                </div>
                              )}

                              <div
                                className="product-thumb-nail"
                                onClick={() => Single_products(items._id)}
                                style={{
                                  position: "relative",
                                  padding: "25px 20px 15px",
                                  background:
                                    "linear-gradient(180deg, #fff5f0 0%, #ffffff 100%)",
                                  flex: "0 0 auto",
                                  minHeight: "200px",
                                }}
                              >
                                <img
                                  className="product-image"
                                  src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                                  alt={items.product_name}
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "contain",
                                    transition: "transform 0.3s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1.05)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                />

                                <div
                                  className="actions"
                                  style={{
                                    position: "absolute",
                                    top: "103px",
                                    right: "15px",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  {token ? (
                                    items.favourite_status == 1 ? (
                                      <button
                                        className="action-btn"
                                        onClick={(e) =>
                                          addfevrate(
                                            items._id,
                                            items.favourite_status,
                                            e,
                                          )
                                        }
                                        style={{
                                          width: "36px",
                                          height: "36px",
                                          borderRadius: "50%",
                                          background:
                                            "rgba(255, 255, 255, 0.9)",
                                          border: "none",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          boxShadow:
                                            "0 4px 12px rgba(0,0,0,0.1)",
                                          cursor: "pointer",
                                          transition: "all 0.2s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                          // Heart icon (SVG) का color change
                                          e.currentTarget.querySelector(
                                            "svg",
                                          ).style.color = "rgb(255, 161, 29)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.querySelector(
                                            "svg",
                                          ).style.color = "#ff4757";
                                        }}
                                      >
                                        <BsFillSuitHeartFill
                                          style={{
                                            color: "#ff4757",
                                            fontSize: "18px",
                                            transition: "all 0.2s ease",
                                          }}
                                        />
                                      </button>
                                    ) : (
                                      <button
                                        className="action-btn"
                                        onClick={(e) =>
                                          addfevrate(
                                            items._id,
                                            items.favourite_status,
                                            e,
                                          )
                                        }
                                        style={{
                                          width: "36px",
                                          height: "36px",
                                          borderRadius: "50%",
                                          background:
                                            "rgba(255, 255, 255, 0.9)",
                                          border: "none",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          boxShadow:
                                            "0 4px 12px rgba(0,0,0,0.1)",
                                          cursor: "pointer",
                                          transition: "all 0.2s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                          // Regular heart icon का color change
                                          e.currentTarget.querySelector(
                                            "i",
                                          ).style.color = "rgb(255, 161, 29)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.querySelector(
                                            "i",
                                          ).style.color = "#666";
                                        }}
                                      >
                                        <i
                                          className="lar la-heart"
                                          style={{
                                            fontSize: "18px",
                                            color: "#666",
                                            transition: "all 0.2s ease",
                                          }}
                                        />
                                      </button>
                                    )
                                  ) : (
                                    <a
                                      href="/login"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        background: "rgba(255, 255, 255, 0.9)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                        textDecoration: "none",
                                        transition: "all 0.2s ease",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.querySelector(
                                          "i",
                                        ).style.color = "rgb(255, 161, 29)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.querySelector(
                                          "i",
                                        ).style.color = "#666";
                                      }}
                                    >
                                      <i
                                        className="lar la-heart"
                                        style={{
                                          fontSize: "18px",
                                          color: "#666",
                                          transition: "all 0.2s ease",
                                        }}
                                      />
                                    </a>
                                  )}

                                  <button
                                    className="action-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      Single_products_model(items._id, e);
                                    }}
                                    style={{
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      background: "rgba(255, 255, 255, 0.9)",
                                      border: "none",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.querySelector(
                                        "i",
                                      ).style.color = "rgb(255, 161, 29)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.querySelector(
                                        "i",
                                      ).style.color = "#666";
                                    }}
                                  >
                                    <i
                                      className="las la-eye"
                                      style={{
                                        fontSize: "18px",
                                        color: "#666",
                                        transition: "all 0.2s ease",
                                      }}
                                    />
                                  </button>
                                </div>
                              </div>

                              <div
                                className="product-content"
                                onClick={() => Single_products(items._id)}
                                style={{
                                  padding: "20px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  flex: "1 0 auto",
                                  background: "#ffffff",
                                }}
                              >
                                <div>
                                  <div
                                    className="product-sub-title"
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      fontWeight: "500",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {items.category_name}
                                  </div>

                                  <h3
                                    className="product-title"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      color: "#333",
                                      // marginBottom: "12px",
                                      lineHeight: "1.4",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      marginBottom: "0px",
                                      // height: "44px"
                                    }}
                                  >
                                    {items.product_name}
                                  </h3>

                                  <div
                                    className="product-price-wrapp"
                                    style={{
                                      // marginBottom: "20px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "3px",
                                    }}
                                  >
                                    {items.offer_percent !== 0 && (
                                      <span
                                        className="product-regular-price"
                                        style={{
                                          fontSize: "13px",
                                          textDecoration: "line-through",
                                          color: "#999",
                                          fontWeight: "500",
                                        }}
                                      >
                                        ₹{items.mrp}
                                      </span>
                                    )}
                                    <span
                                      className="product-price-on-sale"
                                      style={{
                                        fontWeight: "700",
                                        fontSize: "16px",
                                        color: "rgb(255, 161, 29)",
                                        display: "inline-block",
                                      }}
                                    >
                                      ₹{items?.price?.[0]}
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        border: "1px solid #e9ecef",
                                        padding: "2px 10px",
                                        borderRadius: "20px",
                                        fontSize: "10px",
                                        color: "#495057",
                                        fontWeight: "500",
                                        background:
                                          "linear-gradient(135deg, rgb(255, 106, 0) 0%, rgb(238, 9, 121) 100%)",
                                        color: "rgb(255, 255, 255)",
                                      }}
                                    >
                                      <strong
                                        style={{
                                          color: "rgb(255, 255, 255)",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {items?.quantity?.[0]}
                                      </strong>
                                    </span>
                                  </div>
                                  {/* <div>
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        border: "1px solid #e9ecef",
                                        padding: "2px 10px",
                                        borderRadius: "20px",
                                        fontSize: "10px",
                                        color: "#495057",
                                        fontWeight: "500",
                                        background:
                                          "linear-gradient(135deg, rgb(255, 106, 0) 0%, rgb(238, 9, 121) 100%)",
                                        color: "rgb(255, 255, 255)",
                                      }}
                                    >
                                      <strong
                                        style={{
                                          color: "rgb(255, 255, 255)",
                                          fontSize: "16px",
                                        }}
                                      >
                                        {items?.quantity?.[0]}
                                      </strong>
                                    </span>
                                  </div> */}
                                </div>

                                <div className="product-cart-btn-wrap">
                                  {token ? (
                                    items.cart_status === "1" ? (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          navigate("/cardlist");
                                        }}
                                        className="btn w-100 py-2"
                                        style={{
                                          borderRadius: "12px",
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          background: "rgb(255, 161, 29)",
                                          color: "#fff",
                                          border: "none",
                                          transition: "all 0.2s ease",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "8px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.background =
                                            "rgb(230, 145, 26)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.background =
                                            "rgb(255, 161, 29)";
                                        }}
                                      >
                                        <i
                                          className="las la-shopping-cart"
                                          style={{ fontSize: "16px" }}
                                        />
                                        Already in Cart
                                      </button>
                                    ) : (
                                      <button
                                        className="btn w-100 py-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          add_to_cart(items, e);
                                        }}
                                        style={{
                                          borderRadius: "12px",
                                          fontWeight: "600",
                                          color: "#fff",
                                          background:
                                            "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))",
                                          border: "none",
                                          fontSize: "14px",
                                          transition: "all 0.2s ease",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "8px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.background =
                                            "linear-gradient(90deg, rgb(255, 138, 0), rgb(255, 106, 0), rgb(255, 61, 0))";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.background =
                                            "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))";
                                        }}
                                      >
                                        <i
                                          className="las la-cart-plus"
                                          style={{ fontSize: "16px" }}
                                        />
                                        Add to Cart
                                      </button>
                                    )
                                  ) : (
                                    <a
                                      href="/login"
                                      className="btn w-100 py-2 text-white"
                                      style={{
                                        borderRadius: "12px",
                                        fontWeight: "600",
                                        color: "#fff",
                                        background:
                                          "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))",
                                        border: "none",
                                        fontSize: "14px",
                                        transition: "all 0.2s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background =
                                          "linear-gradient(90deg, rgb(255, 138, 0), rgb(255, 106, 0), rgb(255, 61, 0))";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background =
                                          "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))";
                                      }}
                                    >
                                      <i
                                        className="las la-sign-in-alt"
                                        style={{ fontSize: "16px" }}
                                      />
                                      Add to Cart
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* <div className="row g-3">
                      {fruits_veg_product_list?.slice(0, 4).map((items) => {
                        return (
                          <div className="new-arrival-carousel-item swiper-slide col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                            <div
                              className="product-card-list"
                              style={{
                                marginRight: "-10px",
                                cursor: "pointer",
                              }}
                            >
                              <div className="product-card">
                                <span
                                  style={{ backgroundColor: "#ffa11d" }}
                                  className="badge product-badge"
                                >
                                  {items.offer_percent === 0
                                    ? ""
                                    : items.offer_percent + "%"}
                                </span>
                                <div 
                                  className="product-thumb-nail"
                                  onClick={() => Single_products(items._id)}
                                >
                                  <span>
                                    <img
                                      className="product-image p-2"
                                      src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                                      alt="image_not_found"
                                    />
                                  </span>
                                  <ul className="actions">
                                    {token ? (
                                      items.favourite_status == 1 ? (
                                        <li className="action whish-list">
                                          <BsFillSuitHeartFill
                                            style={{ color: "red" }}
                                            onClick={(e) =>
                                              addfevrate(
                                                items._id,
                                                items.favourite_status,
                                                e
                                              )
                                            }
                                          />
                                        </li>
                                      ) : (
                                        <li
                                          className="action whish-list"
                                          onClick={(e) =>
                                            addfevrate(
                                              items._id,
                                              items.favourite_status,
                                              e
                                            )
                                          }
                                        >
                                          <i className="lar la-heart" />
                                        </li>
                                      )
                                    ) : (
                                      <li className="action whish-list">
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            window.$('#loginRequiredModal').modal('show');
                                          }}
                                        >
                                          <i className="lar la-heart" />
                                        </button>
                                      </li>
                                    )}
                                    <li className="action quick-view">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          Single_products_model(items._id, e);
                                        }}
                                      >
                                        <i className="las la-eye" />
                                      </button>
                                    </li>
                                  </ul>
                                </div>

                                <div className="product-content" onClick={() => Single_products(items._id)}>
                                  <h4 className="product-sub-title">
                                    {items.category_name}
                                  </h4>
                                  <h3 className="product-title">
                                    {items.product_name}
                                  </h3>
                                  <div className="product-price-wrapp">
                                    <span className="product-regular-price">
                                      ₹{items.mrp}
                                    </span>
                                    <span className="product-price-on-sale">
                                      ₹{items?.price?.[0]}
                                    </span>
                                  </div>
                                  <div className="product-cart-btn-wrap">
                                    {token ? (
                                      items.cart_status === "1" ? (
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            navigate("/cardlist");
                                          }}
                                          className="btn btn-success add-to-cart-btn btn-lg w-100 py-3"
                                        >
                                          Already in Cart
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-dark add-to-cart-btn"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            add_to_cart(items, e);
                                          }}
                                        >
                                          Add to cart
                                        </button>
                                      )
                                    ) : (
                                      <button 
                                        className="btn btn-dark add-to-cart-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          window.$('#loginRequiredModal').modal('show');
                                        }}
                                      >
                                        Add to cart
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div> */}
                  </div>

                  <div
                    className="vertical-scroll-container"
                    style={{ marginBottom: "20px" }}
                  >
                    {/* <div className="row g-3">
                      {fruits_veg_product_list
                        .slice(0, 4)
                        .reverse()
                        ?.map((items) => {
                          return (
                            <div className="new-arrival-carousel-item swiper-slide col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                              <div
                                className="product-card-list"
                                style={{
                                  marginRight: "-10px",
                                  cursor: "pointer",
                                }}
                              >
                                <div className="product-card">
                                  <span
                                    style={{ backgroundColor: "#ffa11d" }}
                                    className="badge product-badge"
                                  >
                                    {items.offer_percent === 0
                                      ? ""
                                      : items.offer_percent + "%"}
                                  </span>
                                  <div 
                                    className="product-thumb-nail"
                                    onClick={() => Single_products(items._id)}
                                  >
                                    <span>
                                      <img
                                        className="product-image p-2"
                                        src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                                        alt="image_not_found"
                                      />
                                    </span>
                                    <ul className="actions">
                                      {token ? (
                                        items.favourite_status == 1 ? (
                                          <li className="action whish-list">
                                            <BsFillSuitHeartFill
                                              style={{ color: "red" }}
                                              onClick={(e) =>
                                                addfevrate(
                                                  items._id,
                                                  items.favourite_status,
                                                  e
                                                )
                                              }
                                            />
                                          </li>
                                        ) : (
                                          <li
                                            className="action whish-list"
                                            onClick={(e) =>
                                              addfevrate(
                                                items._id,
                                                items.favourite_status,
                                                e
                                              )
                                            }
                                          >
                                            <i className="lar la-heart" />
                                          </li>
                                        )
                                      ) : (
                                        <li className="action whish-list">
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              window.$('#loginRequiredModal').modal('show');
                                            }}
                                          >
                                            <i className="lar la-heart" />
                                          </button>
                                        </li>
                                      )}
                                      <li className="action quick-view">
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            Single_products_model(items._id, e);
                                          }}
                                        >
                                          <i className="las la-eye" />
                                        </button>
                                      </li>
                                    </ul>
                                  </div>

                                  <div className="product-content" onClick={() => Single_products(items._id)}>
                                    <h4 className="product-sub-title">
                                      {items.category_name}
                                    </h4>
                                    <h3 className="product-title">
                                      {items.product_name}
                                    </h3>
                                    <div className="product-price-wrapp">
                                      <span className="product-regular-price">
                                        ₹{items.mrp}
                                      </span>
                                      <span className="product-price-on-sale">
                                        ₹{items?.price?.[0]}
                                      </span>
                                    </div>
                                    <div className="product-cart-btn-wrap">
                                      {token ? (
                                        items.cart_status === "1" ? (
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              navigate("/cardlist");
                                            }}
                                            className="btn btn-success add-to-cart-btn btn-lg w-100 py-3"
                                          >
                                            Already in Cart
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-dark add-to-cart-btn"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              add_to_cart(items, e);
                                            }}
                                          >
                                            Add to cart
                                          </button>
                                        )
                                      ) : (
                                        <button 
                                          className="btn btn-dark add-to-cart-btn"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            window.$('#loginRequiredModal').modal('show');
                                          }}
                                        >
                                          Add to cart
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div> */}
                  </div>

                  <div className="text-end mt-2">
                    <button
                      className="btn btn-primary px-5 py-2 fw-bold"
                      onClick={() => navigate("/shop")}
                      style={{ backgroundColor: "#ffa11d", border: "none" }}
                    >
                      View All Products
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="modal fade" id="f_v_addto-cart-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-dark border-bottom-0 justify-content-center">
              {cardstatus == true ? (
                <h4 className="modal-title text-white">
                  Product successfully added to your shopping cart
                </h4>
              ) : (
                <h4 className="modal-title text-white">
                  Already added to your shopping cart
                </h4>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="myModal1"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className="modal-content"
            style={{
              borderRadius: "24px",
              border: "none",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
            }}
          >
            {/* Modern Header with Gradient */}
            <div
              className="modal-header border-0 p-4"
              style={{
                background: "linear-gradient(135deg, #ff9e16 0%, #ffbb5b 100%)",
                position: "relative",
              }}
            >
              <h5 className="modal-title text-white mb-0">
                <i className="fas fa-eye me-2"></i>
                Product Details
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white close"
                data-dismiss="modal"
                onClick={removelocal_showcard}
                style={{
                  filter: "brightness(0) invert(1)",
                  fontSize: "18px",
                }}
              ></button>
            </div>

            {showmodel?.length > 0 ? (
              <div className="modal-body p-0">
                <div className="row g-0">
                  {/* Image Section - Left */}
                  <div className="col-md-6 bg-light">
                    <div className="p-4 p-lg-5">
                      {/* Main Image with Modern Frame */}
                      <div className="position-relative mb-4">
                        <div
                          className="bg-white rounded-4 p-4 shadow-sm"
                          style={{
                            border: "1px solid #eef2f7",
                            minHeight: "380px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {images && images.length > 0 && (
                            <>
                              <img
                                src={`${process.env.REACT_APP_API}uploads/${images[slideIndex]}`}
                                alt={showmodel[0]?.product_name}
                                className="img-fluid"
                                style={{
                                  maxHeight: "320px",
                                  objectFit: "contain",
                                  transition: "transform 0.3s ease",
                                }}
                              />

                              {/* Image Counter Badge */}
                              <div className="position-absolute top-0 start-0 m-3">
                                <span className="badge bg-dark bg-opacity-75 text-white px-3 py-2 rounded-pill">
                                  <i className="fas fa-image me-1"></i>
                                  {slideIndex + 1} / {images.length}
                                </span>
                              </div>

                              {/* Modern Navigation Buttons */}
                              {images.length > 1 && (
                                <>
                                  <button
                                    onClick={() => plusSlides(-1)}
                                    className="btn btn-light btn-lg rounded-circle shadow position-absolute start-0 ms-3"
                                    style={{
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: "48px",
                                      height: "48px",
                                      background: "rgba(255,255,255,0.9)",
                                      backdropFilter: "blur(10px)",
                                    }}
                                  >
                                    <i className="fas fa-chevron-left"></i>
                                  </button>
                                  <button
                                    onClick={() => plusSlides(1)}
                                    className="btn btn-light btn-lg rounded-circle shadow position-absolute end-0 me-3"
                                    style={{
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: "48px",
                                      height: "48px",
                                      background: "rgba(255,255,255,0.9)",
                                      backdropFilter: "blur(10px)",
                                    }}
                                  >
                                    <i className="fas fa-chevron-right"></i>
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      {/* Modern Thumbnail Gallery */}
                      {images && images.length > 1 && (
                        <div className="d-flex justify-content-center gap-3 overflow-auto pb-3">
                          {images.map((image, index) => (
                            <button
                              key={index}
                              onClick={() => currentSlide(index)}
                              className={`flex-shrink-0 border-2 rounded-3 overflow-hidden p-1 ${index === slideIndex ? "border-primary" : "border-light"}`}
                              style={{
                                width: "80px",
                                height: "80px",
                                background: "white",
                                transition: "all 0.3s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "scale(1.05)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = "scale(1)")
                              }
                            >
                              <img
                                src={`${process.env.REACT_APP_API}uploads/${image}`}
                                alt={`Thumbnail ${index + 1}`}
                                className="img-fluid rounded-2"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Product Info Section - Right */}
                  <div className="col-md-6">
                    <div className="p-4 p-lg-5 h-100">
                      {/* Product Title & Category */}
                      <div className="mb-4">
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill">
                            <i className="fas fa-tag me-2"></i>
                            {showmodel[0]?.category_name}
                          </span>
                          {showmodel[0]?.offer_percent > 0 && (
                            <span className="badge bg-danger text-white px-3 py-2 rounded-pill">
                              <i className="fas fa-bolt me-2"></i>-
                              {showmodel[0]?.offer_percent}% OFF
                            </span>
                          )}
                        </div>

                        <h2
                          className="h3 fw-bold text-dark mb-3"
                          style={{ lineHeight: "1.3" }}
                        >
                          {showmodel[0]?.product_name}
                        </h2>

                        {/* Modern Rating */}
                        <div className="d-flex align-items-center gap-3 mb-4">
                          <div className="text-warning">
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star-half-alt"></i>
                          </div>
                        </div>
                      </div>

                      {/* Modern Price Display */}
                      <div
                        className="mb-4 p-4 rounded-4"
                        style={{
                          background:
                            "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                        }}
                      >
                        <div className="d-flex align-items-end gap-3 mb-2">
                          <span className="h2 fw-bold  product-price-on-sale-lg">
                            ₹{counter_price}
                          </span>
                          {showmodel[0]?.mrp > counter_price && (
                            <>
                              <span className="h5 text-muted text-decoration-line-through">
                                ₹{showmodel[0]?.mrp}
                              </span>
                              <span className="badge bg-success text-white px-3 py-2 rounded-pill">
                                <i className="fas fa-save me-1"></i>
                                Save ₹{showmodel[0]?.mrp - counter_price}
                              </span>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Description */}
                      <div className="mb-4">
                        <h6 className="text-uppercase text-muted small fw-bold mb-3">
                          <i className="fas fa-info-circle me-2"></i>
                          Description
                        </h6>
                        <p
                          className="text-dark mb-0"
                          style={{ lineHeight: "1.6", fontSize: "15px" }}
                        >
                          {showmodel[0]?.description}
                        </p>
                      </div>

                      {/* Quantity Variants */}
                      {showmodel[0]?.quantity?.length > 0 && (
                        <div className="mb-4">
                          <h6 className="text-uppercase text-muted small fw-bold mb-3">
                            <i className="fas fa-box me-2"></i>
                            Available Sizes
                          </h6>
                          <div className="d-flex flex-wrap gap-2">
                            {showmodel[0]?.quantity.map((item, index) => (
                              <button
                                key={index}
                                onClick={() => qantity_index(index)}
                                className="btn btn-success m-1  rounded-pill px-4 py-2 position-relative"
                                style={{
                                  transition: "all 0.3s ease",
                                  borderWidth: "2px",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(-2px)";
                                  e.currentTarget.style.boxShadow =
                                    "0 5px 15px rgba(0,0,0,0.1)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(0)";
                                  e.currentTarget.style.boxShadow = "none";
                                }}
                              >
                                {item}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Quantity & Add to Cart - Modern Layout */}
                      <div className="mb-4">
                        <h6 className="text-uppercase text-muted small fw-bold mb-3">
                          <i className="fas fa-sort-amount-up me-2"></i>
                          Quantity
                        </h6>
                        <div className="row g-3 align-items-center">
                          <div className="col-md-4">
                            <div className="input-group input-group-lg border rounded-4 overflow-hidden">
                              <button
                                onClick={decrement}
                                className="btn btn-light border-0 px-3 py-3"
                              >
                                <i className="fas fa-minus"></i>
                              </button>
                              <input
                                type="text"
                                className="form-control border-0 text-center fs-5 fw-bold"
                                value={counter}
                                readOnly
                                style={{ maxWidth: "70px" }}
                              />
                              <button
                                onClick={increment}
                                className="btn btn-light border-0 px-3 py-3"
                              >
                                <i className="fas fa-plus"></i>
                              </button>
                            </div>
                          </div>

                          <div className="col-md-8">
                            {token ? (
                              showmodel[0]?.cart_status === "1" ? (
                                <button
                                  onClick={() => navigate("/cardlist")}
                                  style={{
                                    background: "rgb(255, 161, 29)",

                                    transition: "all 0.3s ease",
                                    border: "none",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "rgb(230, 145, 26)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "rgb(255, 161, 29)";
                                  }}
                                  className="btn  btn-lg w-100 py-3 rounded-4 fw-bold"
                                >
                                  <i className="fas fa-shopping-cart me-2"></i>
                                  View in Cart
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    add_to_cart_model(showmodel[0])
                                  }
                                  className="btn  w-100 py-3 rounded-4 fw-bold"
                                  style={{
                                    transition: "all 0.3s ease",
                                    border: "none",
                                    background:
                                      "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "linear-gradient(90deg, rgb(255, 138, 0), rgb(255, 106, 0), rgb(255, 61, 0))";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))";
                                  }}
                                >
                                  <i className="fas fa-shopping-cart me-2"></i>
                                  Add to Cart
                                </button>
                              )
                            ) : (
                              <a
                                href="/login"
                                className="btn btn-primary w-100 py-3 rounded-4 fw-bold text-decoration-none"
                                style={{
                                  transition: "all 0.3s ease",
                                  background:
                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                  border: "none",
                                  display: "block",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.transform =
                                    "translateY(-2px)")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.transform =
                                    "translateY(0)")
                                }
                              >
                                <i className="fas fa-sign-in-alt me-2"></i>
                                Login to Purchase
                              </a>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Modern Action Buttons */}
                      <div className="row g-3 mb-4">
                        {/* Wishlist Button */}
                        <div className="col-md-12">
                          {token ? (
                            showmodel[0]?.favourite_status === "1" ? (
                              <button
                                onClick={() =>
                                  addfevrate(
                                    showmodel[0]?._id,
                                    showmodel[0]?.favourite_status,
                                  )
                                }
                                className="btn btn-outline-danger w-100 py-3 rounded-4 fw-bold"
                                style={{
                                  transition: "all 0.3s ease",
                                  borderWidth: "2px",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(-2px)";
                                  e.currentTarget.style.boxShadow =
                                    "0 5px 15px rgba(220,53,69,0.2)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(0)";
                                  e.currentTarget.style.boxShadow = "none";
                                }}
                              >
                                <i className="fas fa-heart me-2"></i>
                                Remove from Wishlist
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  addfevrate(
                                    showmodel[0]?._id,
                                    showmodel[0]?.favourite_status,
                                  )
                                }
                                className="btn btn-outline-secondary w-100 py-3 rounded-4 fw-bold"
                                style={{
                                  transition: "all 0.3s ease",
                                  borderWidth: "2px",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(-2px)";
                                  e.currentTarget.style.boxShadow =
                                    "0 5px 15px rgba(0,0,0,0.1)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(0)";
                                  e.currentTarget.style.boxShadow = "none";
                                }}
                              >
                                <i className="far fa-heart me-2"></i>
                                Add to Wishlist
                              </button>
                            )
                          ) : (
                            <a
                              href="/login"
                              className="btn btn-outline-secondary w-100 py-3 rounded-4 fw-bold text-decoration-none"
                              style={{
                                transition: "all 0.3s ease",
                                borderWidth: "2px",
                                display: "block",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(-2px)";
                                e.currentTarget.style.boxShadow =
                                  "0 5px 15px rgba(0,0,0,0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                                e.currentTarget.style.boxShadow = "none";
                              }}
                            >
                              <i className="far fa-heart me-2"></i>
                              Login for Wishlist
                            </a>
                          )}
                        </div>
                      </div>

                      {/* Social Sharing - Modern Design */}
                    
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              /* Modern Loading Animation */
              <div
                className="modal-body d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: "500px" }}
              >
                <div
                  className="spinner-border text-primary mb-4"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderWidth: "3px",
                  }}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FruitsandVagetables;
